// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){

	// New Baytek Block
	$('.carousel-slider').each(function(){
		var slickIndividual = $(this);
		slickIndividual.slick({
			centerMode: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			variableWidth: true,
			adaptiveHeight: false,
			prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
			nextArrow: '<button type="button" class="slick-next slick-arrow"></button>'
		});
	});

	$('.related-slides > .wp-block-group__inner-container').each(function() {
		var slickHighlights = $(this);
		slickHighlights.slick({
			centerMode: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			draggable: true,
			infinite: true,
			variableWidth: true,
			nextArrow: slickHighlights.closest('.related-content').find('.right'),
			prevArrow: slickHighlights.closest('.related-content').find('.left'),
		});
	});

	$('.video-quote-slider').each(function() {
		var slideCount = null;
		var slickQuotes = $(this);
		
		slickQuotes.slick({
			lazyLoad: 'ondemand',
			centerMode: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			draggable: true,
			infinite: true,
			variableWidth: false,
			prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
			nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
		});


		slickQuotes.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			setCurrentSlideNumber(nextSlide);
		});
		if ($(document).width() < 720) {
			var columnHeight = $('.video-quote-slider .quote-slide .wp-block-column:first-child figure').height() + 24;
			$('.video-quote-slider .slick-arrow').css({'top': columnHeight, 'transform': 'none'});
			console.log(columnHeight);
		}
	});

	if ($(document).attr("dir") == 'rtl') { 
		$('.slick-slider').slick('slickSetOption', 'rtl', true, true);
	}
	function setCurrentSlideNumber(currentSlide) {
		var $el = $('.slide-count-wrap').find('.current');
		$el.text(currentSlide + 1);
	};

})(jQuery);